var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{ref:"footer",staticClass:"transparent mt-5"},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_vm._v(" COPYRIGHT © "+_vm._s((new Date().getFullYear()))+" "),_c('a',{staticClass:"text-decoration-none",attrs:{"href":"#","target":"_blank"}},[_vm._v("Store Execution")]),_vm._v(", Tous droits réservés ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }